import { MutationKey } from '@tanstack/query-core';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { AppID, SpaceID } from '@playq/octopus-common';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { experimentsQueryKeys } from '/api/hooks/experimentsService';
import { flowQueryKeys } from '/api/hooks/flows';
import { gameEventsQueryKeys } from '/api/hooks/gameEventsService';

import { spacePromotionsCleanKey } from './constants';

export type UseAppSpacePromotionsCleanParams = {
  appID: AppID;
  spaceID: SpaceID;
};

export const useAppSpacePromotionsClean = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, UseAppSpacePromotionsCleanParams>
) => {
  return useEitherMutation(({ appID, spaceID }) => services2.spacesPromotionsService.cleanPromotions(appID, spaceID), {
    removeQueriesKeysArray: [experimentsQueryKeys, flowQueryKeys, gameEventsQueryKeys],
    mutationKey: spacePromotionsCleanKey as MutationKey,
    ...options,
  });
};
